module.exports = __webpack_public_path__ + "img/Jeff_Doctor.1e33ebe4.jpg";